export const removeNewIdFromObject = <T extends { id: string }>(values: T[]): (Omit<T, 'id'> | T)[] => {
  return values.map((item) => {
    if (item.id.includes('new-')) {
      const { id, ...rest } = item;
      return rest;
    }
    return item;
  });
};
